function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M24.054 2.117h1v13.175h-1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.638 6.759l-.654-.756 3.451-2.987H6.769L2.27 6.759l-.654-.756 4.78-3.987h18.722l-5.48 4.743z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M22.776 7.526l-1.333 1.155V5.049L3.649 4.882 5.004 3.76h17.772v3.766zM26.934 21.097h3.45v8.5h-3.45z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2.616 19.285V6.97h16.2v9.63a1.41 1.41 0 011 .118V5.97h-18.2v14.315h17.431a6.783 6.783 0 01-.688-1zM25.047 15.3l-.682-.73-3.138 2.95c.257.175.536.377.828.594z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M16.441 16.783a1.414 1.414 0 00-1.167-1.034l-1.368-1.368-2.194-2.194a3.048 3.048 0 00.216-.617 2.913 2.913 0 00.077-.671 3 3 0 00-.891-2.134A3.048 3.048 0 008.3 7.954a3.093 3.093 0 00-.613.207l1 1 1 1-.445 1.089-1.081.45-1-1-1-1a3.024 3.024 0 00-.183.574 3 3 0 00.827 2.752 3.047 3.047 0 002.152.884 3.139 3.139 0 00.61-.06 3.027 3.027 0 00.569-.175l2.219 2.225 1.309 1.3a1.45 1.45 0 00.045.31 1.414 1.414 0 002.732-.732zm-.6.553l-.009.033a.759.759 0 01-.537.538l-.033.009a.76.76 0 01-.734-.2L14.5 17.7a.758.758 0 01-.2-.734l.008-.033a.762.762 0 01.538-.538l.033-.009a.761.761 0 01.734.2l.024.024a.761.761 0 01.205.726zM25.947 21.534c-.9-1.738-2.138-1.387-2.85-1.912-.6-.438-3.288-2.627-3.8-2.09a1.566 1.566 0 00-.18 1.79 6.89 6.89 0 001.462 1.837c-4.982.764-10.163-.462-11.293.5a1.8 1.8 0 00.423 2.391 1.266 1.266 0 00-.31 2.506c-.606-.106-.915.714-.831 1.324.091.667 1.143 1.091 1.672 1.192 7.33 1.006 8.261 1.384 15.533.07"
})));

var SvgWagonListmin = function SvgWagonListmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWagonListmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WagonList.min.acad8233.svg";
export { ForwardRef as ReactComponent };